import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { LeadsService } from "../../services/lead-service/lead-service.service";
import { HttpClient } from "@angular/common/http";
import { ProjectsService } from "../../services/projects/projects.service";
import { ReservationService } from "../../services/reservation-service/reservation.service";
import {
  etaNonTacableTaxTypes,
  etaTaxTypes,
} from "../../../assets/eta-taxes-info";

@Component({
  selector: "app-eta-reports",
  templateUrl: "./eta-reports.component.html",
  styleUrls: ["./eta-reports.component.scss"],
})
export class EtaReportsComponent implements OnInit {
  eta_report: Array<any> = [];
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));
  last_page_url: any;
  prev_page_url: any;
  filterForm: FormGroup;
  filterActive = false;
  filterData: any;
  is_refreshing = false;
  per_page: any;
  total: any;
  current_page: any = 1;
  eta_report_raw_data: any;
  manageTable: any = {
    lead_name: true,
    unit_serial: true,
    status: true,
    building: true,
    garden_area: true,
    price: true,
    date: true,
    agent: true,
    contract_generated: false,
    unit_area: true,
  };
  toogleManageTable = {
    lead_name: false,
    unit_serial: false,
    status: false,
    building: false,
    garden_area: false,
    price: false,
    date: false,
    agent: false,
    contract_generated: true,
    unit_area: false,
  };
  reservation = {
    onColor: "primary",
    offColor: "danger",
    onText: "Enable",
    offText: "Disable",
    value: "",
    size: "",
  };
  lg = "lg";
  projects: any;

  active_tab: any = "filter";
  tax_types = [...etaTaxTypes, ...etaNonTacableTaxTypes];

  @ViewChild("topScroll") topScroll: ElementRef;
  @ViewChild("tableScroll") tableScroll: ElementRef;

  developers;

  constructor(
    private router: Router,
    public fb: FormBuilder,
    public slimLoadingBarService: SlimLoadingBarService,
    public errorHandlerService: ErrorHandlerService,
    public leadsService: LeadsService,
    private http: HttpClient,
    public projectService: ProjectsService,
    private reservationService: ReservationService
  ) {}

  ngOnInit() {
    this.createForms();
    this.getEtaReport();
    this.getDevelopers();
  }

  getDevelopers() {
    this.projectService.getDevelopers().subscribe((res) => {
      this.developers = res;
    });
  }

  makeTableScrollable() {
    setTimeout(() => {
      //console.log(this.topScroll, this.tableScroll);

      // Synchronize scroll between the top scrollbar and the actual table
      this.topScroll.nativeElement.addEventListener("scroll", () => {
        this.tableScroll.nativeElement.scrollLeft =
          this.topScroll.nativeElement.scrollLeft;
      });

      this.tableScroll.nativeElement.addEventListener("scroll", () => {
        this.topScroll.nativeElement.scrollLeft =
          this.tableScroll.nativeElement.scrollLeft;
      });
    }, 1000);
  }

  createForms() {
    this.filterForm = this.fb.group({
      status: [null],
      type: [null],
      internal_id: [null],
      date_from: [""],
      date_to: [""],
      customer_name: [""],
      developer_id: [""],
      unit_id: [""],
      tax_type: [""],
    });
  }

  getTaxName(tax_type: string) {
    return etaTaxTypes.find((t) => t.code === tax_type).desc_ar;
  }

  getEtaReport(is_export: boolean = false) {
    this.slimLoadingBarService.start();
    let payload = { ...this.filterForm.value, page: this.current_page };
    if (is_export) {
      payload = {
        ...payload,
        is_export: 1,
      };
    }
    this.reservationService.getEtaReports(payload).subscribe((data: any) => {
      if (is_export) {
        window.open(data.url);
      } else {
        setTimeout(() => {
          this.makeTableScrollable();
        }, 2000);
        this.eta_report_raw_data = data;
        this.eta_report = data.data.map((eta) => {
          return {
            ...eta,
            taxes: eta.taxes.map((tax) => {
              return {
                ...tax,
                tax_name: this.getTaxName(tax.type),
              };
            }),
          };
        });
        //console.log(this.eta_report);
        this.last_page_url = data.last_page_url;
        this.per_page = data.to;
        this.total = data.total;
      }
      this.slimLoadingBarService.complete();
    }),
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      };
  }

  resetFilters() {
    this.createForms();
    this.getEtaReport();
  }

  pageChange(event) {
    this.current_page = event;
    this.getEtaReport();
  }

  toggleChange($event, type) {
    this.manageTable[type] = !$event;
  }

  setFilterActiveTab() {
    if (this.active_tab == "" || this.active_tab == "sales-status") {
      this.active_tab = "filter";
    } else {
      this.active_tab = "";
    }
  }

  setSalesStatusTab() {
    if (this.active_tab == "" || this.active_tab == "filter") {
      this.active_tab = "sales-status";
    } else {
      this.active_tab = "";
    }
  }

  isCustomerCare() {
    return this.userProfile.role == "Customer Care" ? true : false;
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/eta-reports/eta-reports.component.ts